import { jsxs as e, jsx as C } from "react/jsx-runtime";
import o from "./icon.js";
const c = (l) => /* @__PURE__ */ e(o, { ...l, children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M17.2872 9.70711C17.6777 9.31658 17.6777 8.68342 17.2872 8.29289C16.8967 7.90237 16.2635 7.90237 15.873 8.29289L10.5801 13.5858L8.28718 11.2929C7.89666 10.9024 7.2635 10.9024 6.87297 11.2929C6.48245 11.6834 6.48245 12.3166 6.87297 12.7071L9.87297 15.7071C10.2635 16.0976 10.8967 16.0976 11.2872 15.7071L17.2872 9.70711Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0801 1C6.00495 1 1.08008 5.92487 1.08008 12C1.08008 18.0751 6.00495 23 12.0801 23C18.1552 23 23.0801 18.0751 23.0801 12C23.0801 5.92487 18.1552 1 12.0801 1ZM3.08008 12C3.08008 7.02944 7.10952 3 12.0801 3C17.0506 3 21.0801 7.02944 21.0801 12C21.0801 16.9706 17.0506 21 12.0801 21C7.10952 21 3.08008 16.9706 3.08008 12Z",
      fill: "currentColor"
    }
  )
] });
export {
  c as CircleCheck,
  c as default
};
